import { browserHistory } from 'react-router';

import {
    SHOW_POPUP,
    HIDE_POPUP,
    SHOW_USER_POPUP,
    HIDE_USER_POPUP,
    SHOW_FORGOT,
    HIDE_FORGOT,
    SHOW_SET_PASSWORD,
    HIDE_SET_PASSWORD,
    SHOW_LOGIN,
    HIDE_LOGIN,
    SHOW_PROGRESS,
    HIDE_PROGRESS,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,
    SIGNUP_REQUEST,
    SIGNUP_SUCCESS,
    SIGNUP_FAIL,
    UPDATE_COMPANY_REQUEST,
    UPDATE_COMPANY_SUCCESS,
    UPDATE_COMPANY_FAIL,
    SHOW_CONTEXT,
    HIDE_CONTEXT,
    SET_PASSWORD_REQUEST,
    SET_PASSWORD_SUCCESS,
    SET_PASSWORD_FAIL,
    SHOW_SAVE_VIEW,
    HIDE_SAVE_VIEW,
    DELETE_VIEW,
    COUNTRIES_REQUEST,
    COUNTRIES_SUCCESS,
    COUNTRIES_FAIL,
    CURRENT_USER_REQUEST,
    CURRENT_USER_SUCCESS,
    CURRENT_USER_FAIL,
    SAVE_NEW_REVISION
} from '../constants/action-types';

import {
    resetPasswordRequest, signupRequest, getCountriesRequest,
    updateCompanyDetailsRequest, setNewPasswordRequest, getCurrentUser
} from '../services/api';

import { isMobileDevice } from '../services/utils';

export function showPopup(popupProps) {
    return {
        type: SHOW_POPUP,
        popupProps: popupProps
    }
}

export function hidePopup() {
    return {
        type: HIDE_POPUP,
    }
}

export function showUserPopup(companyId) {
    return {
        type: SHOW_USER_POPUP,
        companyId
    }
}

export function hideUserPopup() {
    return {
        type: HIDE_USER_POPUP,
    }
}

export function showForgotPopup() {
    return {
        type: SHOW_FORGOT,
    }
}

export function hideForgotPopup() {
    return {
        type: HIDE_FORGOT,
    }
}

export function resetPassword(email) {
    return (dispatch) => {
        dispatch({ type: RESET_PASSWORD_REQUEST });
        resetPasswordRequest(email).then(result => {
            dispatch({ type: HIDE_FORGOT });
            dispatch({ type: RESET_PASSWORD_SUCCESS });
            dispatch({
                type: SHOW_POPUP,
                popupProps: {
                    title: 'You should receive an email shortly!',
                    content: 'Please follow the instructions in the email',
                    buttonText: 'Ok',
                    buttonAction: () => browserHistory.push('/')
                }
            });
        }).catch(error => {
            dispatch({ type: HIDE_FORGOT });
            dispatch({ type: RESET_PASSWORD_FAIL });
            let errCode = error.response.status;
            let content = (errCode === 404)
                ? 'The email is not registered'
                : (errCode === 418 
                    ? 'Your company is not approved'
                    : 'There was an error when requesting');
            dispatch({
                type: SHOW_POPUP,
                popupProps: {
                    title: 'Error',
                    content: content,
                    centered: true,
                    buttonText: 'Close',
                    buttonAction: () => browserHistory.push('/')
                }
            });
        });
    }

}

export function showLogin() {
    return {
        type: SHOW_LOGIN
    }
}

export function hideLogin() {
    return {
        type: HIDE_LOGIN,
    }
}

export function showContext(x, y, params) {
    return {
        type: SHOW_CONTEXT,
        x, y, params
    }
}

export function hideContext() {
    return {
        type: HIDE_CONTEXT,
    }
}

export function customAction(action, addtionalProps = {}) {
    return {
        type: action || 'UNKNOWN_ACTION',
        ...addtionalProps
    };
}

export function showSaveView() {
    return {
        type: SHOW_SAVE_VIEW,
    }
}

export function hideSaveView() {
    return {
        type: HIDE_SAVE_VIEW,
    }
}

export function signup(data, cb) {
    return (dispatch) => {
        dispatch({ type: SIGNUP_REQUEST });
        dispatch({ type: HIDE_USER_POPUP });
        dispatch({ type: SHOW_PROGRESS });
        signupRequest(data).then(result => {
            dispatch({ type: SIGNUP_SUCCESS });
            dispatch({ type: HIDE_PROGRESS });
            dispatch({
                type: SHOW_POPUP,
                popupProps: {
                    title: 'Signup success',
                    content: 'Thank you for signing up! Once we have accepted the submitted information, we will send all registered users an email in which you need to set your password.',
                    buttonText: 'Ok',
                    buttonAction: () => {
                        if (typeof cb == 'function') cb();
                    }
                }
            });
        }).catch(error => {
            dispatch({ type: SIGNUP_FAIL });
            dispatch({ type: HIDE_PROGRESS });
            dispatch({
                type: SHOW_POPUP,
                popupProps: {
                    title: 'Error',
                    content: 'There was an error when signing up',
                    buttonText: 'Dismiss'
                }
            });
        });
    }

}


export function updateCompanyDetails(data, isRegularUser, cb) {  
    return (dispatch) => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: `Updating ${isRegularUser ? 'your': ''} company details`,
                content: `You are going to update ${isRegularUser ? 'your': ''}  company details. Are you sure?`,
                isConfirm: true,
                buttonAction: () => {
                    dispatch({ type: UPDATE_COMPANY_REQUEST });
                    dispatch({ type: SHOW_PROGRESS });
                    updateCompanyDetailsRequest(data).then(result => {
                        dispatch({ type: HIDE_PROGRESS });
                        dispatch({ type: UPDATE_COMPANY_SUCCESS });
                        dispatch({ type: HIDE_USER_POPUP });
                        if (isRegularUser) {
                            return getCurrentUserRefresh(dispatch, cb);
                        }
                        if (typeof cb == 'function') cb();
                    }).catch(error => {
                        dispatch({ type: HIDE_PROGRESS });
                        dispatch({ type: UPDATE_COMPANY_FAIL });

                        let errCode = error.response.status;
                        if (errCode === 403) {
                            dispatch({
                                type: SHOW_POPUP,
                                popupProps: {
                                    title: 'Error',
                                    content: 'You do not have permisson to edit company and user details',
                                    centered: true,
                                    buttonText: 'Close'
                                }
                            });
                        } else if (errCode === 400) {
                            dispatch({
                                type: SHOW_POPUP,
                                popupProps: {
                                    title: 'Error',
                                    content: error.response.data,
                                    centered: true,
                                    buttonText: 'Close'
                                }
                            });
                        }
                                    
                        console.log(error);
                    });
                }
            }
        });
    }
}

export function setNewPassword(params, cb) {
    return (dispatch) => {
        dispatch({ type: SET_PASSWORD_REQUEST });
        setNewPasswordRequest(params).then(result => {
            dispatch({ type: SET_PASSWORD_SUCCESS }); 
            cb();           
            
            if (!isMobileDevice()) {
                browserHistory.push('/login');            
            }
            else {
                dispatch({
                    type: SHOW_POPUP,
                    popupProps: {
                        title: 'Reset success',
                        content: 'Your password has been changed! Please log in again.',
                        buttonText: 'Login',
                        url: '/login'
                    }
                });
            }
        }).catch(error => {
            dispatch({ type: SET_PASSWORD_FAIL });
            browserHistory.push('/');
            cb();
            dispatch({
                type: SHOW_POPUP,
                popupProps: {
                    title: 'Error',
                    content: 'There was an error when resetting.',
                    buttonText: 'Dismiss'
                },
            });
        });
    }
}

export function showSetPasswordPopup() {
    return {
        type: SHOW_SET_PASSWORD,
    }
}

export function hideSetPasswordPopup() {
    return {
        type: HIDE_SET_PASSWORD,
    }
}

export function showProgress() {
    return {
        type: SHOW_PROGRESS,
    }
}

export function hideProgress() {
    return {
        type: HIDE_PROGRESS,
    }
}

export function getCountriesList() {
    return (dispatch) => {
        dispatch({ type: COUNTRIES_REQUEST });
        getCountriesRequest().then(result => {
            dispatch({
                type: COUNTRIES_SUCCESS,
                payload: result.data
            });
        }).catch(error => {
            dispatch({ type: COUNTRIES_FAIL });
            console.log(error)
        });
    }
}

export function requestRefresh() {
    return (dispatch) => {
        dispatch({
            type: SHOW_POPUP,
            popupProps: {
                title: 'New version',
                content: 'The DirectHedge website was updated. Please reload this page.',
                buttonText: 'Ok',
                buttonAction: () => { window.location.reload(); }
            }
        });
    }
}

export function checkVersion(newRevision) {
    return (dispatch, getState) => {
        if (!newRevision) {
            return;
        }
        const currentRevision = getState().app.serverRevision;
        if (currentRevision && currentRevision != newRevision) {
            dispatch({ type: SAVE_NEW_REVISION, data: newRevision });
            dispatch(requestRefresh());
        }
        else if (!currentRevision) {
            dispatch({ type: SAVE_NEW_REVISION, data: newRevision });
        }
    };
}

const getCurrentUserRefresh = (dispatch, cb) => {
    dispatch({ type: CURRENT_USER_REQUEST });
    getCurrentUser().then(result => {
        dispatch({
            type: CURRENT_USER_SUCCESS,
            payload: result.data
        });
        if (cb && typeof cb == 'function') cb();
    }).catch(error => {
        dispatch({
            type: CURRENT_USER_FAIL,
            error: error
        });
    });
};



// WEBPACK FOOTER //
// ./source/actions/appActions.js